(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4031],{

/***/ 22275:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/expert/[id]",
      function () {
        return __webpack_require__(11984);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 11984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68380);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46099);
/* harmony import */ var _components_AppLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42413);
/* harmony import */ var _components_FloatingGroup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50724);
/* harmony import */ var _services_tracking__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19676);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var ExpertDetail = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 2709).then(__webpack_require__.bind(__webpack_require__, 2709)).then(function(mod) {
        return mod.ExpertDetail;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2709)
            ];
        }
    }
});
var ExpertDetailPage = function(props) {
    var ref, ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, {
                noindex: "production" !== "production",
                nofollow: "production" !== "production"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AppLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                layoutType: "full",
                isGnbExist: false,
                floatingArea: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FloatingGroup__WEBPACK_IMPORTED_MODULE_5__/* .FloatingGroup */ .X, _objectSpread({
                    onlyTopButton: true
                }, _services_tracking__WEBPACK_IMPORTED_MODULE_6__/* ["default"].tagGTM */ .Z.tagGTM("expert_detail_top_button", {
                    "expert-id": props === null || props === void 0 ? void 0 : (ref = props.detailData) === null || ref === void 0 ? void 0 : (ref1 = ref.agentDetail) === null || ref1 === void 0 ? void 0 : ref1.code
                }))),
                content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ExpertDetail, {
                    detailData: props === null || props === void 0 ? void 0 : props.detailData,
                    constructionCaseData: props.constructionCaseData
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ExpertDetailPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9344,8974,378,2413,9606,9774,2888,179], function() { return __webpack_exec__(22275); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);